/* global axios */
import ApiClient from './ApiClient';

class GoogleAdsAPI extends ApiClient {
  constructor() {
    super('google_ads_connections', { accountScoped: true });
  }

  generateAuthorization() {
    return axios.post(`${this.baseUrl()}/google_ads/authorization`);
  }

  customers(id) {
    return axios.get(`${this.url}/${id}/customers`);
  }

  // customerId: conta escolhida no ponto de uso (workflow); sem ele o backend
  // cai no customer_id legado da conexao.
  conversionActions(id, customerId) {
    return axios.get(`${this.url}/${id}/conversion_actions`, {
      params: customerId ? { customer_id: customerId } : {},
    });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { google_ads_connection: data });
  }

  // Salva as contas de anuncio marcadas numa conexao (multiplas), pro relatorio.
  saveAdAccounts(id, selectedAdAccounts) {
    return this.update(id, { selected_ad_accounts: selectedAdAccounts });
  }

  test(id) {
    return axios.post(`${this.url}/${id}/test`);
  }

  getAudiences() {
    return axios.get(`${this.baseUrl()}/google_ads/audiences`);
  }

  createAudience(payload) {
    return axios.post(`${this.baseUrl()}/google_ads/audiences`, payload);
  }

  syncAudience(id) {
    return axios.post(`${this.baseUrl()}/google_ads/audiences/${id}/sync`);
  }

  deleteAudience(id) {
    return axios.delete(`${this.baseUrl()}/google_ads/audiences/${id}`);
  }

  // range { since, until } em YYYY-MM-DD (periodo da barra de contexto).
  // Sem connectionId, o backend AGREGA todas as contas marcadas na config,
  // de todas as conexoes. Devolve { data, accounts }.
  insights(connectionId, range = {}) {
    const params = { since: range.since, until: range.until };
    if (connectionId) params.connection_id = connectionId;
    return axios.get(`${this.baseUrl()}/google_ads/insights`, { params });
  }
}

export default new GoogleAdsAPI();
